<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
  export default {
    name:"App"
  }
</script>

<style>
/* Import Montserrat font globally */
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

/* Apply Montserrat globally to all elements */
* {
  font-family: 'Montserrat', sans-serif !important;
}

/* Vuetify specific overrides */
.v-application {
  font-family: 'Montserrat', sans-serif !important;
}

.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .text-subtitle-1,
.v-application .text-subtitle-2,
.v-application .text-body-1,
.v-application .text-body-2,
.v-application .text-button,
.v-application .text-caption,
.v-application .text-overline {
  font-family: 'Montserrat', sans-serif !important;
}
</style>
